export default "__VITE_ASSET__Cuj5onHe__"